import {
  Component,
  ElementRef,
  Inject,
  inject,
  OnInit,
  ViewChild,
} from "@angular/core";
import { FormsModule } from "@angular/forms";

import {
  ComparisonDef,
  JurisdictionResult,
} from "../regcompare/statediff-model";
import { SearchFilterComponent } from "../search-filter/search-filter.component";
import { PublicationService } from "../publication/publication.service";
import { AppMaterialModule } from "../app-material/app-material.module";
import { HelpInfoService } from "../_common/help-info.service";
import {
  MatDialog,
  MatDialogConfig,
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogModule,
} from "@angular/material/dialog";
import { SimpleSearchResult } from "../apptool/model/TemplateList";
import { PageEvent } from "@angular/material/paginator";
import { DynamicDataSource } from "../pocket-ref/pocket-ref/pocket-ref.component";
import { FlatTreeControl } from "@angular/cdk/tree";
import { PublicationModel, PublicationNode } from "../publication/publication";
import { MatTreeModule } from "@angular/material/tree";
import { AlertifyService } from "../_models/alertify.service";
import { HttpErrorResponse } from "@angular/common/http";
import { title } from "process";
@Component({
  selector: "app-search",
  imports: [SearchFilterComponent, AppMaterialModule, MatDialogModule],
  templateUrl: "./search.component.html",
  styleUrls: ["./search.component.css"],
})
export class SearchComponent {
  @ViewChild(SearchFilterComponent) searchFilter!: SearchFilterComponent;
  paginator: any;
  constructor(
    public dataService: PublicationService,
    public dialog: MatDialog,
    private alertifyService: AlertifyService,
    private helpInfoService: HelpInfoService,
  ) {}
  comparisonDef: ComparisonDef[] = [];
  isLoading = false;
  offset = 0;
  limit = 10;

  filterCheckboxDisabled = true; // no filter condtion is placed.
  hasFilter = false;
  isFilterVisible = true;
  noResultsMessage = "";
  displayData: SimpleSearchResult[] = [];
  fetchedData: SimpleSearchResult[] = [];
  filteredData: SimpleSearchResult[] = [];
  searchwords: string = "";
  totalCount: number = 0;
  currentCount: number = 0;
  collectionExcluded: number[] = [];
  collectionNames: number[] = [];
  countryExcluded: string[] = [];
  countryNames: string[] = [];
  jurisdictionNames: string[] = [];
  jurisdictionExcluded: string[] = [];
  pageNumber: number = 1;
  filterJurisdictions: JurisdictionResult[] = [];
  searchTopics: string = "";
  searchQuestionType?: number;

  onApplySearch(pa: {
    tk: string;
    st: JurisdictionResult[];
    keywords: string;
    questionType?: number;
  }) {
    this.isLoading = true;
    this.clearParameters();
    if (!pa.keywords || pa.keywords.length === 0) {
      this.isLoading = false;
      this.fetchedData = [];
      this.displayData = [];
      this.filteredData = [];
      this.totalCount = 0;
      this.filterCheckboxDisabled = true;
      this.hasFilter = false;
      this.countryNames = [];
      this.jurisdictionNames = [];
      this.filterJurisdictions = [];
      this.collectionNames = [];
      return;
    }
    if (window.innerWidth <= 768) {
      this.isFilterVisible = false;
      setTimeout(() => window.dispatchEvent(new Event("resize")), 0);
    }
    this.searchwords = pa.keywords;
    this.filterJurisdictions = pa.st;
    this.searchTopics = pa.tk;
    this.searchQuestionType = pa.questionType;
    this.dataService
      .querySimpleTextSearch(
        pa.keywords,
        this.filterJurisdictions,
        pa.tk,
        this.offset * this.limit,
        this.limit,
        pa.questionType,
      )
      .subscribe(
        (res) => {
          this.isLoading = false;

          // The first item is the total count. The rest are data items. Skip the first item.
          const newData = res.slice(1);
          this.totalCount = parseInt(res[0].productName);

          // Initialize fetchedData as sparse array and populate first page
          this.fetchedData = [];
          const startIndex = this.offset * this.limit;
          const requiredLength = startIndex + newData.length;

          // Ensure the fetchedData array has the right length
          while (this.fetchedData.length < requiredLength) {
            this.fetchedData.push(null as any);
          }

          // Insert first page data at the correct position
          for (let i = 0; i < newData.length; i++) {
            this.fetchedData[startIndex + i] = newData[i];
          }

          console.log(
            `Total count: ${this.totalCount}, Fetched items for page 1: ${newData.length}`,
          );

          // Update collections based on all loaded data (non-null items only)
          const validData = this.fetchedData.filter((item) => item !== null);
          this.collectionNames = [
            ...new Set(validData.map((item) => item.collection)),
          ];
          this.countryNames = [
            ...new Set(validData.map((item) => item.country)),
          ].sort();
          this.jurisdictionNames = [
            ...new Set(validData.map((item) => item.jurisdiction)),
          ].sort();
          this.filterCheckboxDisabled = false;
          this.hasFilter = false;
          this.noResultsMessage = "";
          this.displayPage(this.pageNumber);
        },
        (err: HttpErrorResponse) => {
          if (err.status === 404) {
            // No data found
            this.alertifyService.warning(
              "No results found for the search terms.",
            );
            this.fetchedData = [];
            this.displayData = [];
            this.filteredData = [];
            this.totalCount = 0;
            this.filterCheckboxDisabled = true;
            this.hasFilter = false;
            this.noResultsMessage = "No results found for the search terms.";
          } else {
            this.alertifyService.error(
              "Error occurred when searching: " + err.message,
            );
          }
          console.error("got an error: " + err.message);
          this.isLoading = false;
        },
      );
  }

  toggleFilter() {
    this.isFilterVisible = !this.isFilterVisible;
  }

  clearParameters() {
    this.offset = 0;
    this.pageNumber = 1;
    this.collectionExcluded = [];
    this.countryExcluded = [];
    this.jurisdictionExcluded = [];
  }
  onListRegCompare() {}
  onFilterCheck() {}

  loadNext(next: boolean) {
    if (next) {
      // Move to next page
      if (this.pageNumber < this.getTotalPages()) {
        this.goToPage(this.pageNumber + 1);
      }
    } else {
      // Move to previous page
      if (this.pageNumber > 1) {
        this.goToPage(this.pageNumber - 1);
      }
    }
  }

  displayPage(page: number) {
    // For display, we need to get the actual data items for this page
    // Extract data directly from fetchedData at the correct indices for this page
    const startIndex = (page - 1) * this.limit;
    const endIndex = page * this.limit;

    // Get the valid (non-null) items from the fetched data for this page range
    const pageItems = [];
    for (let i = startIndex; i < endIndex && i < this.fetchedData.length; i++) {
      if (this.fetchedData[i] !== null && this.fetchedData[i] !== undefined) {
        pageItems.push(this.fetchedData[i]);
      }
    }

    // Filter the page items based on current filters
    this.displayData = pageItems.filter(
      (item) =>
        !this.collectionExcluded.includes(item.collection) &&
        !this.countryExcluded.includes(item.country) &&
        !this.jurisdictionExcluded.includes(item.jurisdiction),
    );
  }

  filterByCollection(included: boolean, collection: number) {
    if (!included) {
      this.collectionExcluded.push(collection);
    } else {
      const index = this.collectionExcluded.indexOf(collection);
      if (index > -1) {
        this.collectionExcluded.splice(index, 1);
      }
    }
    this.filterOnPage();
  }

  // Filter by Country
  filterByCountry(included: boolean, country: string) {
    if (!included) {
      this.countryExcluded.push(country);
    } else {
      const index = this.countryExcluded.indexOf(country);
      if (index > -1) {
        this.countryExcluded.splice(index, 1);
      }
    }
    this.filterOnPage();
  }

  // Filter by Jurisdiction
  filterByJurisdiction(included: boolean, jurisdiction: string) {
    if (!included) {
      this.jurisdictionExcluded.push(jurisdiction);
    } else {
      const index = this.jurisdictionExcluded.indexOf(jurisdiction);
      if (index > -1) {
        this.jurisdictionExcluded.splice(index, 1);
      }
    }
    this.filterOnPage();
  }

  // Filter on Page
  filterOnPage(filterChanged: boolean = true) {
    // Filter out null values and apply user filters
    this.filteredData = this.fetchedData.filter(
      (item) =>
        item !== null &&
        item !== undefined &&
        !this.collectionExcluded.includes(item.collection) &&
        !this.countryExcluded.includes(item.country) &&
        !this.jurisdictionExcluded.includes(item.jurisdiction),
    );
    if (filterChanged) {
      this.pageNumber = 1;
      if (this.jurisdictionExcluded.length === 0) {
        this.jurisdictionNames = [
          ...new Set(this.filteredData.map((item) => item.jurisdiction)),
        ].sort();
      }
      this.displayPage(this.pageNumber);
    }
  }

  /**
   * Display dialog for help information. HelpInfoDialog is defined
   * @param evt
   * @param idx
   */
  openHelpInfo(evt: MouseEvent, idx: number): void {
    this.helpInfoService.open(evt, idx);
  }

  onShowProtocol(
    acronym: string,
    topic?: string,
    rulebook?: string,
    section?: string,
    paraNum?: string,
  ) {
    let title = "";
    this.dataService.showLoadingAnimation(true);
    this.dataService.queryTitle(acronym).subscribe(
      (result) => {
        this.dataService.showLoadingAnimation(false);
        title = result.title;
        const dialogConfig = new MatDialogConfig();
        dialogConfig.data = {
          acronym,
          topic,
          rulebook,
          section,
          paraNum,
          title,
          searchWord: this.searchwords,
        };
        dialogConfig.width = "1200px";
        dialogConfig.maxHeight = "90vh";
        dialogConfig.id = "show-protocol-dialog";
        const dialogRef = this.dialog.open(ProtocolDisplay, dialogConfig);

        return dialogRef
          .afterClosed()
          .toPromise()
          .then((result) => {
            return Promise.resolve(result);
          });
      },
      (err: HttpErrorResponse) => {
        this.dataService.showLoadingAnimation(false);
        console.error("got an error: " + err.message);
      },
    );
  }

  onReload() {}

  onSaveSearchDefinition() {
    // Get the selected search definition name if one is selected
    let selectedSearchName = "";
    if (this.searchFilter?.selectedDefinitionId) {
      const selectedDefinition = this.searchFilter.displayDef.find(
        (def: any) => def.id === this.searchFilter.selectedDefinitionId,
      );
      if (selectedDefinition) {
        selectedSearchName = selectedDefinition.searchName;
      }
    }

    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      searchTerms: this.searchwords,
      jurisdictions: this.filterJurisdictions,
      selectedSearchName: selectedSearchName,
    };
    dialogConfig.width = "50vw";
    dialogConfig.id = "save-search-dialog";
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = false;
    dialogConfig.panelClass = "draggable-dialog";

    const dialogRef = this.dialog.open(SaveSearchDialog, dialogConfig);

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.searchName) {
        // Pass the selected definition ID if one is selected, otherwise undefined for new saves
        const selectedId = this.searchFilter?.selectedDefinitionId || undefined;

        this.dataService
          .saveSearchDefinition(
            result.searchName,
            this.searchwords,
            this.filterJurisdictions,
            this.searchTopics,
            this.searchQuestionType,
            selectedId,
          )
          .subscribe(
            (response) => {
              this.alertifyService.success(
                `Search definition "${result.searchName}" saved successfully!`,
              );
              console.log("Search definition saved:", response);

              // Refresh the list if the Search Name accordion is currently open
              if (this.searchFilter?.isSearchDefPanelOpen) {
                this.searchFilter.openSearchDef(result.searchName);
              }
            },
            (error) => {
              this.alertifyService.error(
                `Failed to save search definition: ${error.message || "Unknown error"}`,
              );
              console.error("Failed to save search definition:", error);
            },
          );
      }
    });
  }

  // Builds a regex pattern from backend-provided matched terms (exact literals)
  private buildHighlightPattern(matchedTerms: string[]): string {
    if (matchedTerms && matchedTerms.length > 0) {
      return matchedTerms
        .slice()
        .sort((a, b) => b.length - a.length)
        .map((t) => t.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"))
        .join("|");
    }
    // Fallback: derive pattern from searchwords when matchedTerms not available
    const quotedPhrases: string[] = [];
    const remainder = this.searchwords.replace(
      /"([^"]+)"|'([^']+)'/g,
      (_, d, s) => {
        quotedPhrases.push(d || s);
        return " ";
      },
    );
    const unquotedTerms = remainder
      .split(/,|\s+/)
      .map((t) => t.trim())
      .filter((t) => t.length > 0 && !STOP_WORDS.has(t.toLowerCase()));
    const quotedPatterns = quotedPhrases.map((p) =>
      p.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"),
    );
    const unquotedPatterns = unquotedTerms.map((t) => {
      const escaped = t.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      if (/\W/.test(t)) return escaped;
      const stem = stemWord(t).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      return `(?<![\\w.])${stem}\\w*`;
    });
    return [...quotedPatterns, ...unquotedPatterns].join("|");
  }

  // Decodes HTML entities and highlights search terms in the result
  renderHtml(html: string, matchedTerms: string[] = []) {
    if (html == null) return null;
    const pattern = this.buildHighlightPattern(matchedTerms);
    if (pattern) {
      html = html.replace(
        new RegExpUtil(pattern, "gi"),
        (match) => `<mark>${match}</mark>`,
      );
    }
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  }

  toggleClass(event: any, className: string) {
    console.log("toggleClass called");
    let toggleElement = event.currentTarget as HTMLElement;
    let elements = toggleElement.previousElementSibling as HTMLElement;
    if (!elements) return false;

    elements.classList.toggle(className);
  }

  // 0: not expandable, 1: expanded, 2: collapsed
  isExpanded(pid: string): number {
    let element = document.getElementById(pid) as HTMLElement;
    if (!element) return 0;
    if (
      element.scrollHeight === element.clientHeight &&
      element.classList.contains("onlyTwoLinesContent")
    ) {
      return 0;
    }
    if (element.classList.contains("onlyTwoLinesContent")) {
      return 1;
    }
    return 2;
  }

  getTotalPages(): number {
    return Math.ceil(this.totalCount / this.limit);
  }

  isLastPage(): boolean {
    return this.pageNumber >= this.getTotalPages();
  }

  getVisiblePages(): number[] {
    const totalPages = this.getTotalPages();
    const current = this.pageNumber;
    const pages: number[] = [];

    // Show current page and surrounding pages
    const start = Math.max(1, current - 1);
    const end = Math.min(totalPages, current + 1);

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    return pages;
  }

  goToPage(page: number): void {
    if (page >= 1 && page <= this.getTotalPages() && page !== this.pageNumber) {
      this.pageNumber = page;

      // Check if the target page data is already loaded
      const startIndex = (page - 1) * this.limit;

      // Check if we have actual data (not null) at the start index for this page
      const hasDataAtStartIndex =
        this.fetchedData.length > startIndex &&
        this.fetchedData[startIndex] !== null;

      if (hasDataAtStartIndex) {
        this.displayPage(page);
      } else {
        // Data is not loaded, need to fetch from backend
        this.loadPageData(page);
      }
    }
  }

  private loadPageData(page: number): void {
    this.isLoading = true;
    const startIndex = (page - 1) * this.limit;

    console.log(
      `Loading page ${page}, startIndex: ${startIndex}, limit: ${this.limit}`,
    );

    this.dataService
      .querySimpleTextSearch(
        this.searchwords,
        this.filterJurisdictions,
        this.searchTopics,
        startIndex,
        this.limit,
        this.searchQuestionType,
      )
      .subscribe(
        (res) => {
          this.isLoading = false;

          let newData;
          let totalCount = this.totalCount; // Use existing total count for subsequent pages

          if (startIndex === 0) {
            // First page: backend includes total count as first item, so skip it
            totalCount = parseInt(res[0].productName);
            this.totalCount = totalCount; // Update the stored total count
            newData = res.slice(1);
            console.log(
              `Page ${page} (first page): Backend includes total count = ${totalCount}`,
            );
          } else {
            // Subsequent pages: backend returns only data items, no total count
            newData = res; // Don't skip first item
            console.log(
              `Page ${page} (subsequent page): Backend returns only data items`,
            );
          }

          console.log(`Raw response for page ${page}:`, res);
          console.log(
            `Page ${page}: Total count = ${totalCount}, returning ${newData.length} items for startIndex ${startIndex}`,
          );
          console.log(
            "New data items:",
            newData.map((item) => item?.productName || "No product name"),
          );

          // Check if we're missing items based on total count
          const expectedItems = Math.min(this.limit, totalCount - startIndex);
          if (newData.length < expectedItems) {
            console.warn(
              `⚠️ Expected ${expectedItems} items but got ${newData.length}. This suggests a backend pagination issue.`,
            );
          }

          // Ensure the fetchedData array has the right length to accommodate the new data at correct indices
          const requiredLength = startIndex + newData.length;
          while (this.fetchedData.length < requiredLength) {
            this.fetchedData.push(null as any);
          }

          // Insert new data at the correct position with detailed logging
          for (let i = 0; i < newData.length; i++) {
            const targetIndex = startIndex + i;
            this.fetchedData[targetIndex] = newData[i];
            console.log(
              `Inserted item ${i + 1} at fetchedData[${targetIndex}]: ${newData[i]?.productName || "No product name"}`,
            );
          }

          console.log(
            `FetchedData length after insertion: ${this.fetchedData.length}`,
          );
          console.log(
            `Non-null items in fetchedData: ${this.fetchedData.filter((item) => item !== null).length}`,
          );

          // Update collections based on all loaded data (non-null items only)
          const validData = this.fetchedData.filter((item) => item !== null);
          this.collectionNames = [
            ...new Set(validData.map((item) => item.collection)),
          ];
          this.countryNames = [
            ...new Set(validData.map((item) => item.country)),
          ].sort();
          this.jurisdictionNames = [
            ...new Set(validData.map((item) => item.jurisdiction)),
          ].sort();

          // Display the page
          this.displayPage(page);
        },
        (err: HttpErrorResponse) => {
          this.isLoading = false;
          if (err.status === 404) {
            this.alertifyService.warning(
              "No data found for the requested page.",
            );
          } else {
            this.alertifyService.error(
              "Error occurred when loading page data: " + err.message,
            );
          }
          console.error("Error loading page data: " + err.message);
        },
      );
  }
}

const STOP_WORDS = new Set([
  "a",
  "about",
  "after",
  "against",
  "all",
  "also",
  "an",
  "and",
  "any",
  "are",
  "as",
  "at",
  "be",
  "been",
  "being",
  "between",
  "but",
  "by",
  "came",
  "can",
  "come",
  "could",
  "de",
  "did",
  "do",
  "does",
  "each",
  "else",
  "en",
  "for",
  "from",
  "get",
  "got",
  "had",
  "has",
  "have",
  "he",
  "her",
  "here",
  "him",
  "his",
  "how",
  "i",
  "if",
  "in",
  "into",
  "is",
  "it",
  "its",
  "just",
  "la",
  "like",
  "make",
  "many",
  "me",
  "might",
  "more",
  "most",
  "much",
  "must",
  "my",
  "never",
  "no",
  "not",
  "now",
  "of",
  "on",
  "only",
  "or",
  "other",
  "our",
  "out",
  "over",
  "said",
  "same",
  "see",
  "she",
  "should",
  "since",
  "so",
  "some",
  "still",
  "such",
  "take",
  "than",
  "that",
  "the",
  "their",
  "them",
  "then",
  "there",
  "these",
  "they",
  "this",
  "those",
  "through",
  "to",
  "too",
  "under",
  "up",
  "very",
  "was",
  "way",
  "we",
  "well",
  "were",
  "what",
  "when",
  "where",
  "which",
  "while",
  "who",
  "will",
  "with",
  "would",
  "www",
  "you",
  "your",
]);

// Simple Porter-style stemmer: strips common suffixes to get a root for prefix matching
function stemWord(word: string): string {
  const w = word.toLowerCase();
  if (w.length <= 3) return w;
  // Order matters: strip longest suffixes first
  if (w.endsWith("ically")) return w.slice(0, -6);
  if (w.endsWith("iness")) return w.slice(0, -5);
  if (w.endsWith("ation")) return w.slice(0, -5);
  if (w.endsWith("ness")) return w.slice(0, -4);
  if (w.endsWith("ment")) return w.slice(0, -4);
  if (w.endsWith("ical")) return w.slice(0, -4);
  if (w.endsWith("ful")) return w.slice(0, -3);
  if (w.endsWith("ing")) return w.slice(0, -3);
  if (w.endsWith("ion")) return w.slice(0, -3);
  if (w.endsWith("ous")) return w.slice(0, -3);
  if (w.endsWith("ive")) return w.slice(0, -3);
  if (w.endsWith("ize")) return w.slice(0, -3);
  if (w.endsWith("ise")) return w.slice(0, -3);
  if (w.endsWith("ed")) return w.slice(0, -2);
  if (w.endsWith("er")) return w.slice(0, -2);
  if (w.endsWith("ly")) return w.slice(0, -2);
  if (w.endsWith("es")) return w.slice(0, -2);
  if (w.endsWith("s") && !w.endsWith("ss")) return w.slice(0, -1);
  return w;
}

class RegExpUtil extends RegExp {
  [Symbol.replace](
    str: string,
    replacement: string | ((substring: string, ...args: any[]) => string),
  ) {
    return RegExp.prototype[Symbol.replace].call(
      this,
      str,
      (match: string) => `<mark>${match}</mark>`,
    );
  }
}

/* Show Protocol Dialog Component */
@Component({
  selector: "show-protocol-dialog",
  templateUrl: "show-protocol.html",
  imports: [MatTreeModule, MatDialogModule, AppMaterialModule],
  styleUrls: ["./search.component.css"],
  standalone: true,
})
export class ProtocolDisplay implements OnInit {
  acronym: string = "";
  topic?: string;
  rulebook?: string;
  section?: string;
  paraNum?: string;
  searchWord?: string;
  title: string = "";
  data = inject(MAT_DIALOG_DATA);
  treeControl: FlatTreeControl<DynamicFlatNode>;
  getLevel = (node: DynamicFlatNode) => node.level;
  isExpandable = (node: DynamicFlatNode) => node.expandable;
  getChildren = (node: TodoItemNode): TodoItemNode[] => node.children;
  hasChild = (_: number, _nodeData: TodoItemFlatNode) => _nodeData.expandable;
  hasNoContent = (_: number, _nodeData: TodoItemFlatNode) =>
    _nodeData.item === "";

  dataSource: DynamicDataSource;
  originData: any[] = [];
  userId: number = 0;

  constructor(
    public dialogRef: MatDialogRef<ProtocolDisplay>,
    public dataService: PublicationService,
  ) {
    dialogRef.disableClose = false;
    this.treeControl = new FlatTreeControl<DynamicFlatNode>(
      this.getLevel,
      this.isExpandable,
    );
  }
  ngOnInit(): void {
    this.acronym = this.data.acronym;
    this.topic = this.data.topic;
    this.rulebook = this.data.rulebook;
    this.section = this.data.section;
    this.paraNum = this.data.paraNum;
    this.searchWord = this.data.searchWord;
    this.title = this.data.title;
    this.dataService.showLoadingAnimation(true);

    this.treeControl = new FlatTreeControl<DynamicFlatNode>(
      this.getLevel,
      this.isExpandable,
    );
    this.dataSource = new DynamicDataSource(this.treeControl, this.dataService);
    this.setupAutoExpand();
    this.dataService.getChild(this.acronym, 0, 0).subscribe(
      (res) => {
        this.originData = res;
        this.dataSource.data = this.initialData(res);
        this.dataService.showLoadingAnimation(false);
      },
      (err: any) => {
        console.error("got an error: " + err.error);
        this.dataService.showLoadingAnimation(false);
      },
    );
  }

  setupAutoExpand(): void {
    if (!this.topic) return;
    const expanded = new Set<number>();
    const targetExpandLevel = this.section ? 3 : this.rulebook ? 2 : 1;

    const shouldExpand = (node: DynamicFlatNode): boolean => {
      if (!node.expandable || expanded.has(node.key)) return false;
      if (node.level === 1) return node.item === this.topic;
      if (node.level === 2)
        return !!this.rulebook && node.item === this.rulebook;
      if (node.level === 3)
        return !!this.section && node.item.includes(this.section);
      return false;
    };

    const sub = this.dataSource.dataChange.subscribe((nodes) => {
      const maxLevel = nodes.reduce((m, n) => Math.max(m, n.level), 0);
      if (maxLevel > targetExpandLevel) {
        sub.unsubscribe();
        return;
      }
      nodes.forEach((node) => {
        if (shouldExpand(node)) {
          expanded.add(node.key);
          this.treeControl.expand(node);
        }
      });
    });
  }

  isHighlighted(node: DynamicFlatNode): boolean {
    if (node.level === 1) return !!this.topic && node.item === this.topic;
    if (node.level === 2) return !!this.rulebook && node.item === this.rulebook;
    if (node.level === 3)
      return !!this.section && node.item.includes(this.section);
    if (node.level === 4)
      return !!this.paraNum && node.item.includes(this.paraNum);
    return false;
  }

  renderLeafNode(node: DynamicFlatNode): string {
    const text = node.item;

    // If paraNum is set, test whether "Para <paraNum>" appears in this node's text
    if (this.paraNum) {
      const escapedPara = this.paraNum.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      const paraRegex = new RegExp(`(Para\\s*${escapedPara})`, "i");
      if (paraRegex.test(text)) {
        // This is the matching para node — highlight "Para paraNum" and search terms
        let result = text.replace(
          paraRegex,
          '<span class="selected"><b>- $1</b></span>',
        );
        if (this.searchWord) {
          const escapedWord = this.searchWord.replace(
            /[.*+?^${}()|[\]\\]/g,
            "\\$&",
          );
          result = result.replace(
            new RegExp(`(${escapedWord})`, "gi"),
            "<mark>$1</mark>",
          );
        }
        return result;
      }
    }

    // Non-matching node: apply standard "- Para" bold formatting only
    return text.replace("Para", "<b>- Para</b>");
  }

  initialData(data: PublicationNode[]): DynamicFlatNode[] {
    data.sort((a, b) => a.name.localeCompare(b.name));
    this.moveElementToStart(
      data,
      data.findIndex((x) => x.name === this.topic),
    );
    return data.map(
      (x) => new DynamicFlatNode(x.name, "x.name", x.id, 1, true),
    );
  }

  moveElementToStart<T>(arr: T[], index: number): void {
    if (index >= 0 && index < arr.length) {
      const [element] = arr.splice(index, 1); // Remove the element and store it
      arr.unshift(element); // Add the element to the beginning
    }
  }
}

export class DynamicFlatNode {
  constructor(
    public item: string, // content to display.
    public index: string, // index key to retrieve its child node.
    public key: number,
    public level = 1,
    public expandable = false,
    public isLoading = false,
  ) {}
}

/**
 * Node for to-do item
 */
export class TodoItemNode {
  children: TodoItemNode[];
  item: string;
}

/** Flat to-do item node with expandable and level information */
export class TodoItemFlatNode {
  item: string;
  level: number;
  expandable: boolean;
}

/* Save Search Dialog Component */
@Component({
  selector: "save-search-dialog",
  templateUrl: "save-search-dialog.html",
  imports: [MatDialogModule, AppMaterialModule, FormsModule],
  styleUrls: ["./search.component.css"],
  standalone: true,
})
export class SaveSearchDialog implements OnInit {
  searchName: string = "";
  data = inject(MAT_DIALOG_DATA);

  constructor(public dialogRef: MatDialogRef<SaveSearchDialog>) {
    dialogRef.disableClose = false;
  }

  ngOnInit(): void {
    // Use selected search name if available, otherwise fall back to search terms
    if (this.data?.selectedSearchName) {
      this.searchName = this.data.selectedSearchName;
    } else if (this.data?.searchTerms) {
      this.searchName = this.data.searchTerms;
    }
  }

  onSave(): void {
    if (this.searchName && this.searchName.trim()) {
      this.dialogRef.close({ searchName: this.searchName.trim() });
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
